import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import PageShell from '../components/site/PageShell';
import { images } from '../config/esanzaContent';
import { contentText, useWebsiteContent } from '../hooks/useWebsiteContent';

const ImpactPage: React.FC = () => {
  const { t } = useTranslation();
  const { page } = useWebsiteContent('impact');
  const readiness = t('site.impact.readiness', { returnObjects: true }) as Array<[string, string]>;
  const targets = t('site.home.targets', { returnObjects: true }) as Array<[string, string]>;
  const mode = contentText(page, 'mode', t('nav.impact', 'Impact'));
  const cleanContent = (value: string, fallback: string) => {
    const blocked = /pmvp|funding-ready|secure setup link|see traceability/i;
    return blocked.test(value || '') ? fallback : value;
  };
  const headline = cleanContent(page?.title || t('site.impact.title', 'Built for measurable proof.'), t('site.impact.title', 'Built for measurable proof.'));
  const subtext = cleanContent(page?.summary || t('site.impact.subtitle', 'eSanza reports operational results only when they are backed by verified farm, training, and traceability records.'), t('site.impact.subtitle', 'eSanza reports operational results only when they are backed by verified farm, training, and traceability records.'));

  return (
  <>
    <SEO
      title="Impact | eSanza"
      description="Impact approach for eSanza agricultural operations and traceability."
      imagePath={images.traceability}
    />
    <PageShell>
      <section className="px-5 pb-20 pt-32 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <p className="text-xs font-extrabold uppercase tracking-[0.24em] text-[#d4af37]">{mode}</p>
          <h1 className="mt-5 max-w-4xl text-5xl font-black leading-[1] tracking-tight md:text-7xl">
            {headline}
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-8 text-white/68">
            {subtext}
          </p>
        </div>
      </section>

      <section className="bg-[#f7f9f4] px-5 py-20 text-[#102016] lg:px-8">
        <div className="mx-auto max-w-7xl">
          <h2 className="text-3xl font-black">{t('site.impact.readiness_title', 'Impact readiness')}</h2>
          <div className="mt-8 grid gap-4 md:grid-cols-4">
            {targets.map(([value, label]) => (
              <div key={value} className="rounded-lg border border-[#dbe5d2] bg-white p-7">
                <div className="text-2xl font-black text-[#14532d]">{value}</div>
                <p className="mt-3 text-sm leading-6 text-[#596959]">{label}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 grid gap-5 md:grid-cols-3">
            {readiness.map(([title, text]) => (
              <div key={title} className="rounded-lg border border-[#dbe5d2] bg-white p-7">
                <h3 className="text-xl font-black">{title}</h3>
                <p className="mt-3 text-sm leading-6 text-[#596959]">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  </>
  );
};

export default ImpactPage;
